/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum DatasetImportResult {
  Successful = 'successful',
  Error = 'error',
  CredentialsInvalid = 'credentials_invalid',
  DatabaseNotFound = 'database_not_found',
  SchemaExists = 'schema_exists',
  InsufficientSpace = 'insufficient_space',
  Aborted = 'aborted',
}
